import { assertNever } from '@/helpers/utils';
import { Area } from '../types';

export const getVehicleTypesByArea = (area: Area): string[] => {
  const { areaType } = area;
  switch (areaType) {
    case 'SINGULAR':
      return area.loadHandlingPoiSpecs.map((item) => item.vehicleTypeId);
    case 'STATIONARY':
      return area.stationaryPoiSpecs.map((item) => item.vehicleTypeId);
    case 'RACKING':
      return [area.vehicleTypeId];
    case 'HIGHWAY':
      return area.highwayPoiSpecs.map((item) => item.vehicleTypeId);
    case 'MANUAL':
      return area.vehicleTypeIds;
    default:
      assertNever(areaType);
  }
};
